import { defineComponent as _defineComponent } from 'vue'
import type { BaseValidation } from '@vuelidate/core'

import type { PropType } from 'vue'

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*#__PURE__*/_defineComponent({
  __name: 'TicketsInput',
  props: {
  modelValue: {
    required: true,
    type: String,
  },
  val: {
    required: true,
    type: Object as PropType<BaseValidation>,
  }, 
  label: {
    required: true,
    type: String,
  },
  type: {
    required: false,
    default: 'text',
    type: String,
  },
  inputclass: {
    required: false,
    default: '',
    type: String,
  },
  cy: {
    required: false,
    type: String,
  }
},
  emits: ['update:modelValue', 'blurred'],
  setup(__props, { expose, emit }) {
  expose();

const props = __props






// eslint-disable-next-line @typescript-eslint/no-unused-vars
const updateValue = (e: Event) => {
  const target = e.target as HTMLInputElement
  emit('update:modelValue', target.value)
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const blur = () => {
  props.val.$touch()
  emit('blurred')
}


const __returned__ = { props, emit, updateValue, blur }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})